let addToastFn;

export const registerToast = (fn) => {
  addToastFn = fn;
};

export const toast = (message, type = "info", options = {}) => {
  if (addToastFn) {
    addToastFn({ message, type, ...options });
  }
};

// // 🔥 Promise Toast
// export const toastPromise = async (promise, messages) => {
//   toast(messages.loading || "Loading...", "info");

//   try {
//     const result = await promise;
//     toast(messages.success || "Success!", "success");
//     return result;
//   } catch (err) {
//     toast(messages.error || "Something went wrong!", "error");
//     throw err;
//   }
// };